import React from 'react';
import { ModalFactory, ModalTitle, Text } from '../../../../components';
import { theme } from '../../../../design';
import { LoadingText, StyledSpinner } from './styles';

export const CategoriesLoader = () => (
  <ModalFactory dataCy="pos-categories-loader" onClose={() => {}} isActive maxWidth={600} closeOnOutSideClick={false} hideCloseButton>
    <ModalTitle>Checking POS Configuration</ModalTitle>
    <LoadingText>Please wait while we read your sales categories</LoadingText>
    <StyledSpinner color={theme.color.secondary[400]} size={64} stroke={6} />
    <Text fontWeight="semibold">Loading...</Text>
  </ModalFactory>
);
